import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import AnalysisChartCard from "./ChartCard";

const data = [
  { name: "January", revenue: 2.5, expenses: 2.3 },
  { name: "February", revenue: 6.2, expenses: 2.2 },
  { name: "March", revenue: 1.3, expenses: 2.0 },
  { name: "April", revenue: 5.3, expenses: 4.5 },
  { name: "May", revenue: 9.1, expenses: 1.8 },
  { name: "June", revenue: 0.5, expenses: 2.0 },
];

const RevenueExpensesChart = () => {
  return (
    <AnalysisChartCard>
      <ResponsiveContainer width="100%" height="80%">
        <BarChart data={data} barSize={60}>
          <CartesianGrid
            vertical={false}
            stroke="#E5E7EB"
            strokeOpacity={0.7}
          />{" "}
          {/* lighter horizontal lines */}
          <XAxis dataKey="name" />
          <YAxis tickCount={10} tick={{ fontWeight: "700" }} />{" "}
          {/* More ticks = more lines = smaller gap */}
          <Tooltip />
          {/* <Legend /> removed */}
          <Bar dataKey="revenue" fill="#3b82f6" stackId="a" name="Revenue" />
          <Bar dataKey="expenses" fill="#ef4444" stackId="a" name="Expenses" />
        </BarChart>
      </ResponsiveContainer>
    </AnalysisChartCard>
  );
};

export default RevenueExpensesChart;
